import * as PubSub from 'pubsub-js';

export enum MESSAGES {
  ENABLE_DEVICE = 'ENABLE_DEVICE',
  DISABLE_DEVICE = 'DISABLE_DEVICE',
  LOCK_DEVICE = 'LOCK_DEVICE',
  UNLOCK_DEVICE = 'UNLOCK_DEVICE',
  ACCOUNT_UPDATE_SESSION = 'ACCOUNT_UPDATE_SESSION',
  BALANCE_CHANGE_UPDATE = 'BALANCE_CHANGE_UPDATE',
  MOBILE_ACCOUNT_DEPOSIT = 'MOBILE_ACCOUNT_DEPOSIT',
  NOTE_INSERT_FAIL = 'NOTE_INSERT_FAIL',
  BET_BUILDER_UPDATE = 'BET_BUILDER_UPDATE'
}

// These exported types are defined here as current TS version does not allow re-exporting types.

export type BetSlipMessageType =
  | 'BET_SLIP.PRICE_CHANGE_FROM_BET_PLACEMENT_ERROR'
  | 'betslip.betOpsFetched'
  | 'betslip.clearStakes'
  | 'betslip.errors'
  | 'betslip.suspension';

export type PriceChangeMessage = { selectionId: string; details: any | null }[];

const allSubscriptions: any = {};
export default {
  clearSubscriptions: (componentName: string) => {
    if (allSubscriptions[componentName] !== undefined) {
      allSubscriptions[componentName].forEach((subscriptionId: string) => PubSub.unsubscribe(subscriptionId));
    }
    delete allSubscriptions[componentName];
  },
  getSubscriptions: () => Object.freeze<any>(Object.assign({}, allSubscriptions)),
  publishMessage: <TTopic extends string, TData = any>(topic: TTopic, data: TData) => {
    PubSub.publish(topic, data);
  },
  setupAddSubscription: <TTopic extends string>(componentName: string) => {
    return <TData = any>(message: TTopic, fn: (topic: TTopic, data: TData) => void) => {
      const subscriptionId = PubSub.subscribe(message, fn);
      if (allSubscriptions[componentName] !== undefined) {
        allSubscriptions[componentName].push(subscriptionId);
      } else {
        allSubscriptions[componentName] = [subscriptionId];
      }
    };
  }
};
